import { useRef } from '@wordpress/element';

function SearchForm( { searchTerm, setSearchTerm, isElasticSearch } ) {
	const { swiftCartTranslations } = window.QalaB2bWholesale.translations;
	const fieldRef = useRef( null );
	const options = window.QalaB2bWholesale.swiftCartObj?.elasticSearchFilters || {};
	const handleSearchInput = event => {
		setSearchTerm( event.target.value );

		if ( isElasticSearch && event.target.value.length > 0 ) {
			wp.hooks.doAction( 'qalaElasticCore.action.doQuery', {
				query: event.target.value,
				options,
			} );
		}
	};

	const clearSearch = () => {
		setSearchTerm( '' );
		fieldRef.current.focus();
	};

	return (
		<div className="qala-b2b-wholesale-swift-cart-search-form">
			<input
				ref={ fieldRef }
				type="text"
				name="qala-b2b-wholesale-swift-cart-search-input"
				onChange={ handleSearchInput }
				value={ searchTerm }
				placeholder={ swiftCartTranslations.searchInputPlaceholder }
				autoComplete="off"
			/>
			{ searchTerm.length > 0 && <button className="qala-b2b-wholesale-swift-cart-search-button btn-type-7" onClick={ clearSearch }></button> }
		</div>
	);
}

export default SearchForm;
